import api from './api';
import { Usuario, ApiResponse } from '../types';

export const usuarioService = {
  listar: async (): Promise<Usuario[]> => {
    const response = await api.get<Usuario[]>('/usuarios');
    return response.data;
  },

  listarTodos: async (): Promise<Usuario[]> => {
    const response = await api.get<Usuario[]>('/usuarios/all');
    return response.data;
  },

  listarPorTenant: async (tenantId: number): Promise<Usuario[]> => {
    const response = await api.get<Usuario[]>(`/usuarios/tenant/${tenantId}`);
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Usuario> => {
    const response = await api.get<Usuario>(`/usuarios/${id}`);
    return response.data;
  },

  cadastrar: async (usuario: Usuario, tenantId?: number): Promise<ApiResponse<Usuario>> => {
    const params = tenantId ? `?tenantId=${tenantId}` : '';
    const response = await api.post<ApiResponse<Usuario>>(`/usuarios${params}`, usuario);
    return response.data;
  },

  atualizar: async (id: number, usuario: Usuario): Promise<ApiResponse<Usuario>> => {
    const response = await api.put<ApiResponse<Usuario>>(`/usuarios/${id}`, usuario);
    return response.data;
  },

  desativar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/usuarios/${id}`);
    return response.data;
  },

  removerTenant: async (id: number, tenantId: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/usuarios/${id}/tenants/${tenantId}`);
    return response.data;
  },

  adicionarTenant: async (id: number, tenantId: number): Promise<ApiResponse<void>> => {
    const response = await api.post<ApiResponse<void>>(`/usuarios/${id}/tenants/${tenantId}`);
    return response.data;
  },

  desvincularDaOrganizacaoAtual: async (): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>('/usuarios/me/tenant');
    return response.data;
  },
};
